import { render, staticRenderFns } from "./ItemListPagination.vue?vue&type=template&id=a132e614&"
import script from "./ItemListPagination.vue?vue&type=script&lang=js&"
export * from "./ItemListPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kael-cadranel/Sites/apps.chateaudeseneffe.be/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a132e614')) {
      api.createRecord('a132e614', component.options)
    } else {
      api.reload('a132e614', component.options)
    }
    module.hot.accept("./ItemListPagination.vue?vue&type=template&id=a132e614&", function () {
      api.rerender('a132e614', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ItemListPagination.vue"
export default component.exports